import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    document: null
}

export const documentsSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        setDocument: (state, action) => {
            state.document = action.payload
        },
        removeDocument: () => initialState
    }
})

export const { setDocument, removeDocument } = documentsSlice.actions
export default documentsSlice.reducer
